import { Flex, Icon, Text } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

function ReskinNavItem({ to, title, icon, isActive, isExpanded, iconProps = {}, ...props }, ref) {
  return (
    <Flex
      as={ReactRouterLink}
      ref={ref}
      gap={3}
      h={20}
      align='center'
      to={to}
      title={title}
      w='full'
      color={isActive ? 'brandPrimary.primary' : 'surface.onSurfaceVariant'}
      pl='15px'
      borderLeft='solid 2px'
      bgColor={isActive ? 'surface.surfaceBright' : 'unset'}
      borderRightRadius='md'
      borderColor={isActive ? 'brandPrimary.primary' : 'transparent'}
      _hover={{ bgColor: 'surface.containerHigh' }}
      transition='padding 0.2s ease-in-out, justify-content 0.2s ease-in-out'
      {...props}
    >
      <Icon
        as={icon}
        boxSize={6}
        flexShrink={0}
        {...iconProps}
      />
      {isExpanded && (
        <Text
          fontSize='sm'
          fontWeight='medium'
          textTransform='capitalize'
          whiteSpace='nowrap'
          overflow='hidden'
        >
          {title}
        </Text>
      )}
    </Flex>
  );
}

export default forwardRef(ReskinNavItem);
